import type { ReactNode } from "react";
import { ScrollView, View, type ViewStyle } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { spacing, useTheme } from "~/styles/theme";

export function Screen({
  children,
  scroll = false,
  style,
}: {
  children: ReactNode;
  scroll?: boolean;
  style?: ViewStyle;
}) {
  const { colors } = useTheme();
  const Container = scroll ? ScrollView : View;
  return (
    <SafeAreaView
      style={{ flex: 1, backgroundColor: colors.background }}
      edges={["top", "left", "right"]}
    >
      <Container
        style={scroll ? undefined : [{ flex: 1 }, style]}
        contentContainerStyle={
          scroll
            ? [
                { paddingHorizontal: spacing.lg, paddingBottom: spacing.xxl },
                style,
              ]
            : undefined
        }
      >
        {scroll ? (
          children
        ) : (
          <View style={[{ flex: 1, paddingHorizontal: spacing.lg }, style]}>
            {children}
          </View>
        )}
      </Container>
    </SafeAreaView>
  );
}
